<template>
  <el-table
    :data="data"
    style="width: 100%"
    size="medium"
    header-row-class-name="supervision-table-header"
    row-class-name="common-table-row"
    class="is-print-hide common-table"
    border
  >
    <el-table-column label="序号" width="120">
      <template slot-scope="scope">
        {{ scope.$index + 1 + pageSize * (pageNo - 1) }}
      </template>
    </el-table-column>
    <el-table-column label="药品通用名" min-width="200" prop="drugName"></el-table-column>
    <el-table-column prop="storeContactsName" label="状态">
      <template #default="{ row: { drugStatus } }">
        <span :class="{ red: drugStatus == 0, green: drugStatus == 1 }">
          {{ drugStatus | adaptStatus }}
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'supervisionList',
  props: {
    pageNo: {
      default: 1
    },
    pageSize: {
      default: 10
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    adaptStatus(val) {
      const statusMap = { 1: '启用', 0: '停用' };
      return statusMap[val];
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-item {
  position: relative;
  padding: 5px 0;

  .drug-title {
    font-weight: 500;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }
}

.red {
  color: #eb3c36;
}

.green {
  color: #1e8dff;
}

.yellow {
  color: #ebb436;
}
</style>
